<script>
  import Hero from './components/Hero.svelte';
  import WhatIsLumina from './components/WhatIsLumina.svelte';
  import WhatAreNFAs from './components/WhatAreNFAs.svelte';
  import AgenticEconomy from './components/AgenticEconomy.svelte';
  import Roadmap from './components/Roadmap.svelte';
  import Team from './components/Team.svelte';
  import LaunchPlan from './components/LaunchPlan.svelte';
  import Button from './lib/ui/Button.svelte';
  import ScrollProgress from './components/ScrollProgress.svelte';

  let menuOpen = false;
</script>

<div class="aurora"></div>
<div class="cosmic-bg">
  <div class="stars"></div>
  <div class="stars" style="animation-duration: 200s; opacity: .6"></div>
</div>
<div class="noise"></div>

<ScrollProgress />
<header style="position: sticky; top: 0; z-index: 30; background: rgba(4,7,10,.35); backdrop-filter: blur(8px); border-bottom: 1px solid rgba(255,255,255,.06)">
  <div class="container" style="display:flex; align-items:center; justify-content:space-between; padding: 14px 0;">
    <div style="display:flex; gap:12px; align-items:center" class="logo-glow">
      <img src="/media/logo.svg" alt="Lumina" width="28" height="28" />
      <strong style="font-family: 'Space Grotesk', Inter, sans-serif; letter-spacing:.3px">Lumina</strong>
    </div>
    <nav class="desktop" style="display:flex; gap: 22px; align-items:center">
      <a href="#what">What is Lumina</a>
      <a href="#nfas">What are NFAs</a>
      <a href="#agentic">Agentic Economy</a>
      <a href="#roadmap">Roadmap</a>
      <a href="#team">Team</a>
      <Button href="#launch" variant="primary">Join the Launch</Button>
    </nav>
  </div>
</header>

<main>
  <Hero />
  <WhatIsLumina />
  <WhatAreNFAs />
  <AgenticEconomy />
  <Roadmap />
  <Team />
  <LaunchPlan />
</main>

<footer>
  <div class="container" style="display:flex; justify-content:space-between; align-items:center; gap: 20px; flex-wrap: wrap;">
    <div>
      © {new Date().getFullYear()} Lumina • Arcturian Labs × Maiga
    </div>
    <div style="display:flex; gap:12px; align-items:center;">
      <Button ariaLabel="Twitter" variant="ghost">Twitter/X</Button>
      <Button ariaLabel="Discord" variant="ghost">Discord</Button>
      <Button ariaLabel="Docs" variant="ghost">Docs</Button>
    </div>
  </div>
</footer>
